<template>
  <div>
    <group-card title="Default DocuSign Email Template" icon="edit">
      <form enctype="multipart/form-data">
        <div class="md-layout">
          <md-field>
            <label>Subject Line</label>
            <md-input v-model="email_subject_line" />
          </md-field>
          <md-field style="display:flex; flex-direction:column;">
            <label>Body</label>
            <md-textarea v-model="email_body" style="min-height: 150px;"></md-textarea>
          </md-field>
        </div>
        <md-dialog-actions>
          <md-button class="md-primary" @click="saveTemplate">Save</md-button>
        </md-dialog-actions>
      </form>
      <md-dialog-alert
        :md-active.sync="alertMessage.status"
        :md-title="alertMessage.title"
        :md-content="alertMessage.message" />
    </group-card>
  </div>
</template>
<script>
import {GroupCard} from "@/components";

export default {
  components: {
    GroupCard
  },
  data() {
    return {
      email_subject_line: '',
      email_body: '',
      alertMessage:{
        title: '',
        status: false,
        message: ''
      }
    }
  },
  methods:{
    async saveTemplate(){
      // security measure to prevent script injection attacks.
      this.email_body = this.email_body.replace(/<script.*?>.*?<\/script>/gi, '');
      axios.post('/api/v1/docusign/save_email_template', {
        emailSubject: this.email_subject_line,
        emailBody: this.email_body
      })
      .then(response => {
        if(response){
          this.alertMessage.status = true;
          this.alertMessage.message = 'Docusign subjet line and body template have been saved successfully';
        }
      })
      .catch(error => {
        this.alertMessage.status = true;
        this.alertMessage.message = 'Error! Template could not be saved';
        console.error(error);
      });
    },
    async fetchDefaultTemplate() {
      axios.get('/api/v1/docusign/get_email_template')
      .then(response => {
        this.email_subject_line = response.data.emailSubject
        this.email_body = response.data.emailBody;
      })
      .catch(error => {
        console.error(error);
      });
    },
  },
  created() {
    this.fetchDefaultTemplate();
  }
}
</script>

